import { useEffect, useState } from 'react'
import confetti from 'canvas-confetti'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation1({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    // Explosion de confettis depuis le centre
    const duration = 3000
    const end = Date.now() + duration

    const frame = () => {
      confetti({
        particleCount: 7,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.6 },
        colors: ['#0F352D', '#1d5c4d', '#FFF198', '#feee80', '#fcf5cc']
      })
      confetti({
        particleCount: 7,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.6 },
        colors: ['#0F352D', '#1d5c4d', '#FFF198', '#feee80', '#fcf5cc']
      })

      if (Date.now() < end) {
        requestAnimationFrame(frame)
      }
    }

    // Lance l'animation
    setTimeout(() => {
      setShowBadge(true)
      frame()
    }, 300)

    // Grande explosion centrale
    setTimeout(() => {
      confetti({
        particleCount: 150,
        spread: 100,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#0F352D', '#1d5c4d', '#FFF198', '#feee80', '#fcf5cc']
      })
    }, 500)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        <div className={`transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          {/* Badge */}
          <div className="w-32 h-32 sm:w-40 sm:h-40 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 mb-6">
            <span className="text-5xl sm:text-7xl">{badge.emoji}</span>
          </div>

          {/* Nom du badge */}
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow text-center animate-pulse drop-shadow-[0_0_30px_rgba(255,241,152,0.5)]">
            {badge.name}
          </div>

          {/* Points */}
          <div className="text-lg sm:text-xl text-tessan-cream text-center mt-2">
            +{badge.points_awarded} points
          </div>

          {/* Description */}
          <div className="text-tessan-cream/70 text-center mt-4 max-w-[280px] sm:max-w-xs">
            {badge.description}
          </div>
        </div>
      </div>
    </AnimationLayout>
  )
}
